/*=========================================================================================
  File Name: module-dashboard.js
  Description: dashboard Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-dashboard-state';
import mutations from './module-dashboard-mutations';
import actions from './module-dashboard-actions';
import getters from './module-dashboard-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
